import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';
import {Injectable} from '@angular/core';

@Injectable()
export class MarketplaceRouteReuseStrategy implements RouteReuseStrategy {
    private storedHandle: DetachedRouteHandle | null = null;

    private isMarketplaceSearch(route: ActivatedRouteSnapshot): boolean {
        return route.routeConfig?.path === '' &&
            route.parent?.routeConfig?.path === 'marketplace';
    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return this.isMarketplaceSearch(route);
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        if (this.isMarketplaceSearch(route)) {
            this.storedHandle = handle;
        }
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return this.isMarketplaceSearch(route) && !!this.storedHandle;
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        if (!this.isMarketplaceSearch(route)) { return null; }
        return this.storedHandle;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

    clear(): void {
        if (this.storedHandle) {
            (this.storedHandle as any).componentRef?.destroy();
        }
        this.storedHandle = null;
    }
}
